import React from "react";
import PropTypes from "prop-types";

function ImageButton({name, value, image, onClick, text}) {
	return (
		<button
			className="image-button"
			name={name}
			value={value}
			onClick={(event) =>
				onClick({ ...event, ...{ target: event.currentTarget } })
			}
		>
			<span>{text ? text : value}</span>
			<img alt="" src={image}></img>
		</button>
	);
};

ImageButton.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	image: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	text: PropTypes.string,
};

ImageButton.defaultProps = {
  text: "",
	onClick: () => null,
}

export default ImageButton;
